const protocolRegex = /(^\w+:|^)/g;
const queryRegex = /\?(.*)/g;
function trimAssetUrl(url) {
  return url?.replace(protocolRegex, '').replace(queryRegex, '');
}
export default trimAssetUrl;